import React, { useState, useEffect, useContext } from "react";
import { EventDataContext } from "../EventDataContext";
import Table from "rc-table";
import "../../styling/Bookings.css";
import { PiCaretUpDownFill } from "react-icons/pi";
import moment from "moment";

const ClientEventsTable = ({ event, brandingColours, onEventClick }) => {
  const { EventData, setEventData } = useContext(EventDataContext);

  // State for sort order and sorted data
  const [sortOrder, setSortOrder] = useState({});
  const [sortedEvents, setSortedEvents] = useState([]);
  const [hoveredEvent, setHoveredEvent] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  // Initialize sortedEvents on mount or when 'event' prop changes
  useEffect(() => {
    setSortedEvents(
      event.map((item, index) => ({ ...item, key: item.id || index }))
    );
  }, [event]);

  // Sorting logic
  const handleSort = (column) => {
    const order = sortOrder[column] === "asc" ? "desc" : "asc";
    setSortOrder({ [column]: order });

    const sorted = [...sortedEvents].sort((a, b) => {
      let valA = a[column];
      let valB = b[column];

      // Convert to lowercase for string comparison
      if (typeof valA === "string") valA = valA.toLowerCase();
      if (typeof valB === "string") valB = valB.toLowerCase();

      if (valA < valB) return order === "asc" ? -1 : 1;
      if (valA > valB) return order === "asc" ? 1 : -1;
      return 0;
    });

    setSortedEvents(sorted);
  };

  const handleDelete = () => {
    // Implement delete logic using selectedRows
    console.log("Deleting rows:", selectedRows);
  };

  const handleDownload = () => {
    // Implement download logic using selectedRows
    console.log("Downloading rows:", selectedRows);
  };

  const rowClassName = () => "custom-table-row";

  const customRowClassName = (record, index) => {
    // Add a class to every row for bottom border
    return "table-row-with-border";
  };

  // Table column definitions
  const columns = [
    {
      title: (
        <div className="custom-header" onClick={() => handleSort("eventName")}>
          <PiCaretUpDownFill className="table-header-icon" />
          Event Name
        </div>
      ),
      dataIndex: "eventName",
      key: "eventName",
      width: 100,
      align: "left",
      render: (text, record) => (
        <a
          onClick={() => { 
            onEventClick(record);
            setEventData(record); // Set context
          }}
          onMouseEnter={() => setHoveredEvent(record.key)}
          onMouseLeave={() => setHoveredEvent(null)}
          style={{
            color:
              hoveredEvent === record.key
                ? brandingColours.primaryColor
                : "#000000",
            textDecoration: hoveredEvent === record.key ? "underline" : "none",
            cursor: hoveredEvent === record.key ? "pointer" : "default",
          }}
        >
          <h4 style={{ margin: "0px" }}>{text}</h4>
        </a>
      ),
    },
    {
      title: (
        <div className="custom-header" onClick={() => handleSort("status")}>
          <PiCaretUpDownFill className="table-header-icon" />
          Event Status
        </div>
      ),
      dataIndex: "status",
      key: "status",
      width: 100,
      align: "left",
      render: (text) => text.toUpperCase(),
    },
    {
      title: (
        <div
          className="custom-header"
          onClick={() => handleSort("expPaymentAmount")}
        >
          <PiCaretUpDownFill className="table-header-icon" />
          Event Total
        </div>
      ),
      dataIndex: "expPaymentAmount",
      key: "expPaymentAmount",
      width: 100,
      align: "left",
    },
    {
      title: (
        <div className="custom-header" onClick={() => handleSort("eventDate")}>
          <PiCaretUpDownFill className="table-header-icon" />
          Event Date
        </div>
      ),
      dataIndex: "eventDate",
      key: "eventDate",
      width: 100,
      align: "left",
      render: (date) => (
        <span>{moment(new Date(date)).format("MMM DD, YYYY")}</span>
      ),
    },
  ];

  return (
    <div>
      <div
        className="client-events-table"
        style={{ border: "1px solid #d9d9d9", paddingLeft: "20px" }}
      >
        <Table
          columns={columns}
          data={sortedEvents}
          scroll={{ x: "100%" }}
          rowClassName={(record, index) =>
            `${rowClassName(record, index)} ${customRowClassName(
              record,
              index
            )}`
          }
          components={{
            header: {
              cell: (props) => (
                <th
                  {...props}
                  style={{
                    borderBottom: "1px solid #D9D9D9",
                    height: "50px",
                    textAlign: "left",
                  }}
                >
                  {props.children}
                </th>
              ),
            },
          }}
        />
      </div>
    </div>
  );
};

export default ClientEventsTable;
